import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthService } from '../../auth/auth.service';
import { AbstractControl } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { AgentService } from '../agent.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
    selector: 'app-agent-reset-password',
    templateUrl: './forgot-password-component.html',

  })
  
  export class ForgotAdminPasswordComponent implements OnInit {
    public isValid: boolean = false;
    public username: string;
    
    constructor(private activatedRoute: ActivatedRoute,
        private sharedService: SharedService, private authService: AuthService, private dialog: MatDialog,private router: Router,
        private localStorageService: LocalStorageService, private agentService: AgentService) {    
        this.sharedService.setHeaderTitle('forget_password');    
        this.username = '';    
       }   
   
    ngOnInit(){} 
    
    validate(event: any) {     
      this.sharedService.setHeaderErrorMessage('forget_password', false, 'notification error', '');
      if (this.username !== '' && this.username.match(EMAIL_REGEX)) {
        this.isValid = true;       
        if (event.keyCode === 13) {
          document.getElementById('btn-click').click();
        }
      } else {
        this.isValid = false;
       
      }
    }
    
    resetPassword(){
      this.sharedService.setHeaderErrorMessage('forget_password', false, 'notification error', '');
      let methodName = this.constructor.name+'.verifyToken';
      this.authService.resetAdminPassword({ 'username': this.username })
        .then(res => {                             
            this.dialog.open(ChangeAdminPasswordSuccessLink, {            
              // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
              data: { message: "test"  }});           
        }).catch((ex)=>{
          window.scrollTo(0, 0);
          this.sharedService.setHeaderErrorMessage('create_new_password', true, 'notification error', "Unable send password reset");       
        });                
    }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-password-success',
  // tslint:disable-next-line:max-line-length
  template: `<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"></button><div class="dialog-info"><p>Please check your inbox for an email to reset your password.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="successOk()">Ok</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangeAdminPasswordSuccessLink {
  // tslint:disable-next-line:max-line-length
  public message: string;
  constructor(private activatedRoute: ActivatedRoute,  @Inject(MAT_DIALOG_DATA) public data: any, private sharedService: SharedService, private authService: AuthService, private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {
       this.message = this.data.message;
  }

  successOk() {
    this.router.navigate(['./internal-user/sign-in']);
  }
}


// WEBPACK FOOTER //
// ./src/app/agent/reset-password/forgot-password-component.ts